import { createSlice } from "@reduxjs/toolkit"
import { resetAll } from "./actions/resetAll"

const initialState = false

export const aguardandoProcessamentoSlice = createSlice({
    name: "aguardandoProcessamento",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        processamentoIniciado: () => {
            return true
        },
        processamentoFinalizado: () => {
            return false
        }
    }
})

export const {
    processamentoIniciado: processamentoIniciadoAction,
    processamentoFinalizado: processamentoFinalizadoAction
} : {
    processamentoIniciado: ActionType<void>,
    processamentoFinalizado: ActionType<void>
} = aguardandoProcessamentoSlice.actions

export default aguardandoProcessamentoSlice.reducer